import { render, staticRenderFns } from "./BaseWarningIcon.vue?vue&type=template&id=7a29fe35"
import script from "./BaseWarningIcon.vue?vue&type=script&lang=js"
export * from "./BaseWarningIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports